import { createFileRoute, redirect } from '@tanstack/react-router'
import { OrganizationsListPage } from '@/pages/Organizations/OrganizationsListPage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/organizations')({
  component: OrganizationsListPage,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/organizations')) {
      throw redirect({ to: '/' })
    }
  },
})
